<div class="container-fluid hero-background">
  <div class="container">
    <div class="row align-items-center">
      <div class="hero-container col-12 col-xl-7">
        <div class="hero-container-copy">
          <h3 class="yellow text-uppercase">
            SAVE TIME, INCREASE SAVINGS, IMPROVE ACCESS
          </h3>
          <h1 class="white">
            the most comprehensive virtual marketplace for<br />
            pharmacies to buy direct.
          </h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid second-container">
  <div class="container">
    <div class="row mb-6">
      <div class="col-12 text-center">
        <h2 class="darkblue mb-3">
          registration is free and takes fewer than five minutes
        </h2>
        <app-button
          [buttonColor]="'green'"
          [buttonText]="'schedule a meeting'"
          [buttonIcon]="'chevronright'"
          [buttonLink]="''"
          [buttonType]="'button'"
          (click)="sendToGa('Schedule Meeting Modal', 'Pharmacy')"
        ></app-button>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 col-xl-4 blue">
        <h2 class="green">why medigi?</h2>
        <p>
          The short answer?
          <b class="darkblue"
            >medigi is the #1 alternative for drug procurement.</b
          >
        </p>
        <p>
          The slightly longer answer? We’re your pharmacy’s best friend AND best
          back up. Our team of specialists focuses on simplifying the drug
          procurement process for health systems across the United States.
        </p>
      </div>
      <div class="col-12 col-xl-8">
        <app-value-prop [location]="'pharmacy'"></app-value-prop>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid third-container darkbg">
  <div class="container">
    <div class="row justify-content-center cardholer">
      <app-large-card
        class="col col-lg-10 card-offset-top"
        [cardType]="'carousel'"
        [cardInfo]="quoteCards"
      ></app-large-card>
    </div>
  </div>

  <div class="container cardsandwich">
    <div class="row align-items-center">
      <div class="col-12 col-xl-5">
        <h2 class="section-carousel-title">who uses medigi?</h2>
        <p class="section-carousel-copy">
          Through our platform, hospital systems, academic medical centers,
          community oncology practices, and alternative site pharmacies can
          purchase medication directly from manufacturers in a more
          cost-effective, simple, and reliable way.
        </p>
      </div>
      <div class="col-12 col-xl-7">
        <div
          *ngIf="showFirstImage"
          class="usagediag userhospital"
          data-aos="fade-left"
          data-aos-offset="200"
          data-aos-delay="0"
          data-aos-once="true"
          data-aos-duration="500"
        >
          <div
            class="titlebadge"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="600"
          >
            Hospitals
          </div>
          <div
            class="exbadge leftbull hd-1"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="800"
          >
            Inpatient Pharmacy
          </div>
          <div
            class="exbadge leftbull hd-2"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="1000"
          >
            Hospital Retail Pharmacy
          </div>
          <div
            class="exbadge rightbull hd-3"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="700"
          >
            Central Fill
          </div>
          <div
            class="exbadge rightbull hd-4"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="900"
          >
            Outpatient Clinics
          </div>
        </div>

        <div
          *ngIf="showSecondImage"
          class="usagediag useraltsites"
          data-aos="fade-left"
          data-aos-offset="200"
          data-aos-once="true"
          data-aos-delay="0"
          data-aos-duration="500"
        >
          <div
            class="titlebadge"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="600"
          >
            Alternative Sites
          </div>
          <div
            class="exbadge leftbull as-1"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="700"
          >
            Home Infusion Pharmacy
          </div>
          <div
            class="exbadge leftbull as-2"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="800"
          >
            Long Term Care
          </div>
          <div
            class="exbadge rightbull as-3"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="900"
          >
            Surgery Center
          </div>
          <div
            class="exbadge rightbull as-4"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="1000"
          >
            Infusion Centers
          </div>
          <div
            class="exbadge rightbull as-5"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="1100"
          >
            Cancer Centers
          </div>
          <div
            class="exbadge rightbull as-6"
            data-aos="zoom-in"
            data-aos-once="true"
            data-aos-delay="1200"
          >
            Oncology Clinics
          </div>
        </div>

        <div class="button-container">
          <div
            class="square-button"
            [ngClass]="showFirstImage ? 'green-button' : 'grey-button'"
            (click)="handleImageCarousel(1)"
          ></div>
          <div
            class="square-button"
            [ngClass]="showSecondImage ? 'green-button' : 'grey-button'"
            (click)="handleImageCarousel(2)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid fourth-container">
  <div class="container">
    <div class="row">
      <div class="fourth-container-left-side col-12 col-xl-5">
        <app-transparent-card></app-transparent-card>
      </div>
      <div class="fourth-container-right-side col-12 col-xl-7">
        <h2 class="fourth-container-title">
          one login, one checkout, three distinct channels.
        </h2>
        <p class="fourth-container-copy">
          medigi is designed to simplify the drug procurement process from all
          angles with a custom user experience. Over 80 manufacturers actively
          post their products with real-time inventory transparency, and a
          dynamic pricing model displays your estimated savings. At medigi, our
          digital hub lets pharmacies easily shop, search, negotiate, and
          request products from manufacturers nationwide.
        </p>
        <p class="fourth-container-copy">
          The medigi product range is constantly evolving based on availability
          and requests, but one thing remains steady: our team’s commitment to
          helping you source medications so your patients can receive the best
          care possible. Products include generic injectables, branded and
          specialty medications, antibiotics, infusion treatments, oncology
          meds, oral solids, and CII’s, among more.
        </p>
      </div>
    </div>
  </div>
</div>

<div class="contaier-fluid fifth-container">
  <div class="container">
    <div class="row">
      <div class="col-12 col-xl-4">
        <h2 class="darkblue mb-3">
          medigi helps pharmacies reach their initiatives.
        </h2>
      </div>
      <div class="col-12 col-xl-8">
        <div class="row">
          <div class="initiative col-xl-4 mb-3">
            <h3 class="initiative-title green">SAVINGS</h3>
            <p class="initiative-copy darkblue">
              Pharmacies can save 40-60% on the MedShorts channel
            </p>
          </div>
          <div class="initiative col-xl-4 mb-3">
            <h3 class="initiative-title green">TRACEABILITY</h3>
            <p class="initiative-copy darkblue">
              Real-time shipping updates from manufacturers
            </p>
          </div>
          <div class="initiative col-xl-4 mb-3">
            <h3 class="initiative-title green">TRACK PERFORMANCE</h3>
            <p class="initiative-copy darkblue">
              Manage your pharmacy’s financial goals using our budget tool
            </p>
          </div>
          <div class="initiative col-xl-4 mb-3">
            <h3 class="initiative-title green">ACCESS</h3>
            <p class="initiative-copy darkblue">
              350+ drug shortages sourced by our customers
            </p>
          </div>
          <div class="initiative col-xl-4 mb-3">
            <h3 class="initiative-title green">TRANSPARENCY</h3>
            <p class="initiative-copy darkblue">
              The price you see is the price you pay
            </p>
          </div>
          <div class="initiative col-xl-4 mb-3">
            <h3 class="initiative-title green">SUSTAINABILITY</h3>
            <p class="initiative-copy darkblue">
              15+ million short-dated units saved from incineration
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid sixth-container darkbg">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div
          class="gradient-card-container"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
          data-aos-once="true"
          data-aos-easing="ease-in-out"
        >
          <div
            class="d-flex justify-content-center align-items-start align-items-center-lg"
          >
            <div class="card-stat">
              <h1 class="mb-0">29%</h1>
            </div>
            <div class="card-copy">
              <h3 class="" text-uppercase>Your Drug Shortage Solution</h3>
              <h2 class="fs-2">
                According to our pharmacies, 29% of all NDCs sourced on medigi
                in 2023 were marked as a drug shortage.
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row qfacts">
      <div class="col-12 col-xl-4">
        <h3 class="yellow">QUICK FACTS</h3>
        <h2 class="pb-4">the medigi difference.</h2>
      </div>

      <div class="col-12 col-xl-8 d-flex flex-wrap">
        <div class="quick-fact">
          <h3 class="quick-fact-title">ASHP drug shortage partner</h3>
          <p class="quick-fact-copy">Identify new drug shortages</p>
        </div>
        <div class="quick-fact">
          <h3 class="quick-fact-title">smart data matching</h3>
          <p class="quick-fact-copy">
            Compare current availability to your pharmacy’s usage
          </p>
        </div>
        <div class="quick-fact">
          <h3 class="quick-fact-title">over $40,000</h3>
          <p class="quick-fact-copy">Average monthly pharmacy savings</p>
        </div>
        <div class="quick-fact">
          <h3 class="quick-fact-title">30 minutes</h3>
          <p class="quick-fact-copy">Average monthly time spent on medigi</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid seventh-container">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-xl-6 py-6">
        <h3 class="green">HOW IT WORKS</h3>
        <h2 class="">medigi makes drug procurement simple.</h2>
        <p class="blue">
          Our goal is to ensure you have access to the best deals on the
          treatments your facility needs. The process is easy to understand, and
          is completed in just a few steps:
        </p>
      </div>
      <div class="seventh-container-right-side col-12 col-xl-6 scrollsection">
        <div class="scrollcards">
          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/desktop-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 1</h6>
                <p class="step-card-copy text-wrap text-left">
                  Explore invetory lists on medigi for full-dated drugs,
                  MedShorts for short-dated, and 503B for compounded drugs
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/check-ribbon-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 2</h6>
                <p class="step-card-copy text-wrap text-left">
                  Secure the best deals directly
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/shipping-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 3</h6>
                <p class="step-card-copy text-wrap text-left">
                  All products ship directly from the manufacturer or designated
                  3PL
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/phone-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 4</h6>
                <p class="step-card-copy text-wrap text-left">
                  Know exactly when new inventory will arrive via real-time
                  shipment updates
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/envelope-icon.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 5</h6>
                <p class="step-card-copy text-wrap text-left">
                  Receive a consolidated invoice after products arrive
                </p>
              </div>
            </div>
          </div>

          <div class="step-card-container">
            <div class="step-card">
              <div class="step-card-left">
                <img
                  src="assets/img/static-pages/medigi/v2-images/step-card-icons/step-1.svg"
                  alt=""
                />
              </div>
              <div class="step-card-right">
                <h6 class="step-card-title">Step 6</h6>
                <p class="step-card-copy text-wrap text-left">
                  Payments are collected on your behalf
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- <app-carousel-static class="stepcards" [type]="'stepcards'" [location]="'pharmacy'"></app-carousel-static> -->
      </div>
    </div>
  </div>
</div>

<div class="container-fluid eighth-container darkbg">
  <div class="container">
    <div class="row">
      <!-- Large card w/ button -->
      <div class="col-12">
        <app-large-card
          [pageLocation]="'pharmacies'"
          [cardType]="'button'"
        ></app-large-card>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid darkbg">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col col-12">
        <div class="d-flex align-items-baseline mb-4 splitheader">
          <h3 class="yellow text-uppercase mr-3">Have questions?</h3>
          <h2 class="white">we have answers.</h2>
        </div>
      </div>
    </div>
    <app-faq class="col-8" [faqType]="'pharmacy'"></app-faq>
  </div>

  <div class="container-fluid tenth-container">
    <div class="container">
      <div class="row">
        <div class="col-12 col-xl-4">
          <h2 class="larger-title mb-4">
            share the power of medigi with others!
          </h2>
          <a
            class="yellow d-flex align-items-center fw-bold mb-4"
            href="#"
            style="font-size: 18px"
          >
            <span
              (click)="openPDF()"
              (click)="sendToGa('Downloaded Buyer PDF', 'Pharmacy')"
              >download our overview</span
            >
            <i class="dx-icon-chevronright"></i>
          </a>
        </div>
        <div class="col-12 col-xl-4 offset-xl-2">
          <h2 class="larger-title">want to learn more?</h2>
          <p class="copy">
            Don’t hesitate to reach out to a representative by phone, email or
            live chat.
          </p>
          <a
            class="yellow d-flex align-items-center fw-bold mb-4"
            href="#"
            style="font-size: 18px; margin-top: 1rem"
            data-toggle="modal"
            data-target="#modal"
          >
            connect with us <i class="dx-icon-chevronright"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
